import React, { useState, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { motion, AnimatePresence } from 'framer-motion';

// Placeholder functions (same as original)
const getLabel = (en, mr) => en;
const hasAccess = (path) => true;
const hasAccessToDropdown = (paths) => paths.some(hasAccess);

// Menu items array (same as original)

// Menu items array embedded in the component
const menuItems = [
  {
    label: getLabel("Home", "होम"),
    path: "/home",
    access: hasAccess("/home"),
  },
  {
    label: getLabel("Student", "विद्यार्थी"),
    path: "/student-register",
    access: hasAccessToDropdown([
      "/student-register",
      "/rollNo",
      "/all-student-report",
      "/leaving-certificate",
      "/bonafide",
      "/caste-report",
      "/minority-report",
      "/agewisereport",
      "/IdCard",
      "/generalregister",
      "/stdpersonaldata",
      "/importexport",
      "/admission-details",
      "/nirgam",
      "/outwordReg",
      "/certificates",
      "/distribution",
      "/shifaras-form",
      "/form-15a",
      "/promote",
    ]),
    children: [
      {
        label: getLabel("New students", "नवीन विद्यार्थी"),
        path: "/student-register",
        access: hasAccess("/student-register"),
      },
      {
        label: getLabel("Admission Forms", "प्रवेश फॉर्म"),
        path: "/admission-details",
        access: hasAccess("/admission-details"),
      },
      {
        label: getLabel("Roll Number", "हजेरी क्रमांक"),
        path: "/rollNo",
        access: hasAccess("/rollNo"),
      },
      {
        label: getLabel("Student Report", "विद्यार्थी अहवाल"),
        path: "/all-student-report",
        access: hasAccess("/all-student-report"),
      },
      {
        label: getLabel("Leaving Certificate", "शाळा सोडल्याचा दाखला"),
        path: "/leaving-certificate",
        access: hasAccess("/leaving-certificate"),
      },
      {
        label: getLabel("Bonafide", "बोनाफाईड"),
        path: "/bonafide",
        access: hasAccess("/bonafide"),
      },
      {
        label: getLabel("Nirgam Report", "निर्गम उतारा"),
        path: "/nirgam",
        access: hasAccess("/nirgam"),
      },
      {
        label: getLabel("Outward Report", "जावक उतारा"),
        path: "/outwordReg",
        access: hasAccess("/outwordReg"),
      },
      {
        label: getLabel("Caste Report", "जात अहवाल"),
        path: "/caste-report",
        access: hasAccess("/caste-report"),
      },
      {
        label: getLabel("Minority Report", "अल्पसंख्याक अहवाल"),
        path: "/minority-report",
        access: hasAccess("/minority-report"),
      },
      {
        label: getLabel("Age Report", "वय अहवाल"),
        path: "/agewisereport",
        access: hasAccess("/agewisereport"),
      },
      {
        label: getLabel("IdCard", "ओळखपत्र"),
        path: "/IdCard",
        access: hasAccess("/IdCard"),
      },
      {
        label: getLabel("General Register 1", "जनरल रजि.1"),
        path: "/generalregister",
        access: hasAccess("/generalregister"),
      },
      {
        label: getLabel("Height/Weight", "वजन/ऊंची"),
        path: "/stdpersonaldata",
        access: hasAccess("/stdpersonaldata"),
      },
      {
        label: getLabel("certificate", "प्रमाणपत्र"),
        path: "/certificates",
        access: hasAccess("/certificates"),
      },
      {
        label: getLabel("Import/Export", "आयात/निर्यात"),
        path: "/importexport",
        access: hasAccess("/importexport"),
      },
      {
        label: getLabel("School Supplies", "शालेय साहित्य"),
        path: "/distribution",
        access: hasAccess("/distribution"),
      },
      {
        label: getLabel("Shifaras Form", "शिफारस फॉर्म"),
        path: "/shifaras-form",
        access: hasAccess("/shifaras-form"),
      },
      {
        label: getLabel("Form 15A", "फॉर्म १५ए"),
        path: "/form-15a",
        access: hasAccess("/form-15a"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("Attendance", "हजेरी"),
    path: "/PresentySheet",
    access: hasAccessToDropdown(["/PresentySheet", "/PresentyReport"]),
    children: [
      {
        label: getLabel("Take Attendance", "हजेरी घ्या"),
        path: "/PresentySheet",
        access: hasAccess("/PresentySheet"),
      },
      {
        label: getLabel("Catalogue", "कॅटलॉग"),
        path: "/PresentyReport",
        access: hasAccess("/PresentyReport"),
      },
    ],
  },
  {
    label: getLabel("Account", "किर्द"),
    path: "/kird",
    access: hasAccessToDropdown(["/kird"]),
    children: [
      {
        label: getLabel("Account", "किर्द"),
        path: "/kird",
        access: hasAccess("/kird"),
      },
    ],
  },
  {
    label: getLabel("Fee", "फी"),
    path: "/atm1",
    access: hasAccessToDropdown(["/atm1", "/pavati"]),
    children: [
      {
        label: getLabel("Add Fee", "फी भरा"),
        path: "/atm1",
        access: hasAccess("/atm1"),
      },
      {
        label: getLabel("Fee Reports", "फी रिपोर्ट"),
        path: "/pavati",
        access: hasAccess("/pavati"),
      },
    ],
  },
  {
    label: getLabel("MDM", "पोषण आहार"),
    path: "/praman",
    access: hasAccessToDropdown([
      "/dainandin",
      "/sadhyachasatha",
      "/aavaksatha",
      "/menu",
      "/magani",
      "/praman",
      "/eggandbananaReport",
      "/chavreport",
      "/BMIReport",
      "/certificate",
    ]),
    children: [
      {
        label: getLabel("Quantity", "आहार प्रमाण"),
        path: "/praman",
        access: hasAccess("/praman"),
      },
      {
        label: getLabel("Menu", "आहार मेनू"),
        path: "/menu",
        access: hasAccess("/menu"),
      },
      {
        label: getLabel("incoming entry", "आवक नोंद"),
        path: "/aavaksatha",
        access: hasAccess("/aavaksatha"),
      },
      {
        label: getLabel("Daily register", "दैनंदिन नोंदवही"),
        path: "/dainandin",
        access: hasAccess("/dainandin"),
      },
      {
        label: getLabel("Current stock", "सध्याचा साठा"),
        path: "/sadhyachasatha",
        access: hasAccess("/sadhyachasatha"),
      },
      {
        label: getLabel("Demand", "मागणी"),
        path: "/magani",
        access: hasAccess("/magani"),
      },
      {
        label: getLabel("Egg/Banana Report", "अंडी/केळी अहवाल"),
        path: "/eggandbananaReport",
        access: hasAccess("/eggandbananaReport"),
      },
      {
        label: getLabel("Taste Report", "चव अहवाल"),
        path: "/chavreport",
        access: hasAccess("/chavreport"),
      },
      {
        label: getLabel("BMI Report", "BMI Report"),
        path: "/BMIReport",
        access: hasAccess("/BMIReport"),
      },
      {
        label: getLabel("Certificate", "प्रमाणपत्र"),
        path: "/certificate",
        access: hasAccess("/certificate"),
      },
    ],
  },
  {
    label: getLabel("Result", "निकालपत्र"),
    path: "/GunaNeendani",
    access: hasAccessToDropdown([
      "/GunaNeendani",
      "/resulthsc",
      "/resultssc",
      "/prgReportwd",
      "/progresssheet",
      "/collectout",
      "/subjectwise",
      "/gradewise",
      "/dailyregister",
      "/boardresult",
      "/Icse",
      "/promote",
    ]),
    children: [
      {
        label: getLabel("Mark Registration", "गुण नोंदणी"),
        path: "/GunaNeendani",
        access: hasAccess("/GunaNeendani"),
      },
      {
        label: getLabel("Progress sheet", "प्रगती पत्रक"),
        path: "/progresssheet",
        access: hasAccess("/progresssheet"),
      },
      {
        label: getLabel("combined result", "एकत्रित निकाल"),
        path: "/collectout",
        access: hasAccess("/collectout"),
      },
      {
        label: getLabel("Subject wise results", "विषयनिहाय निकाल"),
        path: "/subjectwise",
        access: hasAccess("/subjectwise"),
      },
      {
        label: getLabel("Grade Wise Results", "श्रेणी निहाय निकाल"),
        path: "/gradewise",
        access: hasAccess("/gradewise"),
      },
      {
        label: getLabel("Daily register", "दैनंदिन नोंदवही"),
        path: "/dailyregister",
        access: hasAccess("/dailyregister"),
      },
      {
        label: getLabel("5th & 8th Result", "५वी आणि ८वी निकाल"),
        path: "/boardresult",
        access: hasAccess("/boardresult"),
      },
      {
        label: getLabel("SSC Result", "SSC निकाल"),
        path: "/resultssc",
        access: hasAccess("/resultssc"),
      },
      {
        label: getLabel("HSC Result", "HSC निकाल"),
        path: "/resulthsc",
        access: hasAccess("/resulthsc"),
      },
      {
        label: getLabel("View Report", "अहवाल पहा"),
        path: "/prgReportwd",
        access: hasAccess("/prgReportwd"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("ICSE Result", "ICSE निकाल"),
    path: "/IcseMarkRegisteration",
    access: hasAccessToDropdown([
      "/IcseMarkRegisteration",
      "/IcseResult",
      "/IcseSubjectWise",
      "/IcseGradeWise",
      "/prgReportwtd",
      "/promote",
      "/Icse",
    ]),
    children: [
      {
        label: getLabel("Mark Registeration", "ICSE निकाल"),
        path: "/IcseMarkRegisteration",
        access: hasAccess("/IcseMarkRegisteration"),
      },
      {
        label: getLabel("Icse Result", "प्रगती पत्रक"),
        path: "/IcseResult",
        access: hasAccess("/IcseResult"),
      },
      {
        label: getLabel("Subject wise results", "विषयनिहाय निकाल"),
        path: "/IcseSubjectWise",
        access: hasAccess("/IcseSubjectWise"),
      },
      {
        label: getLabel("Grade Wise Results", "श्रेणी निहाय निकाल"),
        path: "/IcseGradeWise",
        access: hasAccess("/IcseGradeWise"),
      },
      {
        label: getLabel("Prelims Result", "प्रगती पत्रक"),
        path: "/Icse",
        access: hasAccess("/Icse"),
      },
      {
        label: getLabel("View Report", "अहवाल पहा"),
        path: "/prgReportwtd",
        access: hasAccess("/prgReportwtd"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("CBSE Result", "CBSE निकाल"),
    path: "/cbsemarkentery",
    access: hasAccessToDropdown(["/cbsemarkentery", "/cbsehsresult", "/cbseresult", "/preprimary", "/cbsesubjectcwise", "/promote"]),
    children: [
      {
        label: getLabel("Mark Registeration", "गुण नोंदणी"),
        path: "/cbsemarkentery",
        access: hasAccess("/cbsemarkentery"),
      },
      {
        label: getLabel("High-school Result", "High-school Result"),
        path: "/cbsehsresult",
        access: hasAccess("/cbsehsresult"),
      },
      {
        label: getLabel("Primary Result", "Primary Result"),
        path: "/cbseresult",
        access: hasAccess("/cbseresult"),
      },
      {
        label: getLabel("Pre-Primary Result", "Pre-Primary Result"),
        path: "/preprimary",
        access: hasAccess("/preprimary"),
      },
      {
        label: getLabel("Subject Wise Result", "Subject Wise Result"),
        path: "/cbsesubjectcwise",
        access: hasAccess("/cbsesubjectcwise"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("Payroll", "कर्मचारी"),
    path: "/addteacher",
    access: hasAccessToDropdown(["/addteacher", "/dailyreport", "/viewattendance", "/TIdCard"]),
    children: [
      {
        label: getLabel("Add Staff", "कर्मचारी भरा"),
        path: "/addteacher",
        access: hasAccess("/addteacher"),
      },
      {
        label: getLabel("Staff Payroll", "कर्मचारी वेतन"),
        path: "/dailyreport",
        access: hasAccess("/dailyreport", "/viewattendance"),
      },
      {
        label: getLabel("Id Card", "ओळखपत्र"),
        path: "/TIdCard",
        access: hasAccess("/TIdCard"),
      },
    ],
  },
  {
    label: getLabel("Exam", "परीक्षा"),
    path: "/teacherandqueform",
    access: hasAccessToDropdown(["/teacherandqueform", "/taketest", "/studentresult"]),
    children: [
      {
        label: getLabel("Create Test", "test तयार करा"),
        path: "/teacherandqueform",
        access: hasAccess("/teacherandqueform"),
      },
      {
        label: getLabel("Take Test", "test घ्या"),
        path: "/taketest",
        access: hasAccess("/taketest"),
      },
      {
        label: getLabel("Result", "निकाल"),
        path: "/studentresult",
        access: hasAccess("/studentresult"),
      },
    ],
  },
  {
    label: getLabel("Time Table", "वेळापत्रक"),
    path: "/addSubject",
    access: hasAccessToDropdown([
      "/addSubject",
      "/principleform",
      "/teachertimetable",
      "/timetableform",
      "/timetableform1",
      "/weekdayform",
      "/addteacher",
    ]),
    children: [
      {
        label: getLabel("Add Subject", "विषय जोडा"),
        path: "/addSubject",
        access: hasAccess("/addSubject"),
      },
      {
        label: getLabel("Add Teacher", "शिक्षक जोडा"),
        path: "/addteacher",
        access: hasAccess("/addteacher"),
      },
      {
        label: getLabel("Assign Class-Subject", "वर्ग-विषय नियुक्त करा"),
        path: "/timetableform",
        access: hasAccess("/timetableform"),
      },
      {
        label: getLabel("Assign Period", "तास नियुक्त करा"),
        path: "/weekdayform",
        access: hasAccess("/weekdayform"),
      },
      {
        label: getLabel("Class Timetable", "वर्गाचे वेळापत्रक"),
        path: "/timetableform1",
        access: hasAccess("/timetableform1"),
      },
      {
        label: getLabel("Teacher's TimeTable", "शिक्षकांचे वेळापत्रक"),
        path: "/teachertimetable",
        access: hasAccess("/teachertimetable"),
      },
      {
        label: getLabel("All TimeTable", "सर्व वेळापत्रक"),
        path: "/principleform",
        access: hasAccess("/principleform"),
      },
    ],
  },
  {
    label: getLabel("Inventory", "इन्व्हेंटरी"),
    path: "/instock",
    access: hasAccessToDropdown(["/instock", "/outstock", "/balancestock"]),
    children: [
      {
        label: getLabel("Stock Inward", "आवक साठा"),
        path: "/instock",
        access: hasAccess("/instock"),
      },
      {
        label: getLabel("Stock Outward", "जावक साठा"),
        path: "/outstock",
        access: hasAccess("/outstock"),
      },
      {
        label: getLabel("Current Stock", "सध्याचा साठा"),
        path: "/balancestock",
        access: hasAccess("/balancestock"),
      },
    ],
  },
  {
    label: getLabel("permission", "परवानगी"),
    path: "/permissionAccess",
    access: hasAccess("/permissionAccess"),
  },
  {
    label: getLabel("Refer & Earn", "Refer & Earn"),
    path: null,
    access: true,
  },
];

const NavigationSearchBar = ({ language = "English" }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  // Memoized filtered menu items for better performance
  const filteredItems = useMemo(() => {
    if (!searchQuery.trim()) return [];
    
    return menuItems
      .filter((item) => {
        const mainMenuMatches =
          item.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (item.path && item.path.toLowerCase().includes(searchQuery.toLowerCase()));

        const submenuMatches = item.children?.some(
          (child) =>
            child.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (child.path && child.path.toLowerCase().includes(searchQuery.toLowerCase()))
        );

        return mainMenuMatches || submenuMatches;
      })
      .map((item) => {
        if (item.children) {
          return {
            ...item,
            children: item.children.filter(
              (child) =>
                child.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (child.path && child.path.toLowerCase().includes(searchQuery.toLowerCase()))
        )  };
        }
        return item;
      })
      .filter((item) => item.access && (item.children ? item.children.length > 0 : true));
  }, [searchQuery]);

  const toggleSearch = useCallback(() => {
    setIsSearchOpen(prev => !prev);
    if (isSearchOpen) {
      setSearchQuery("");
    }
  }, [isSearchOpen]);

  const handleItemClick = useCallback(() => {
    setIsSearchOpen(false);
    setSearchQuery("");
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {/* Search Button */}
      <Tooltip title={language === "English" ? "Search Menu" : "नेव्हिगेशन शोधा"} arrow>
        <motion.button
          onClick={toggleSearch}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            boxShadow: '0 4px 15px rgba(118, 75, 162, 0.3)',
          }}
          whileHover={{ 
            scale: 1.1,
            boxShadow: '0 6px 20px rgba(118, 75, 162, 0.4)'
          }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: 'spring', stiffness: 400, damping: 17 }}
        >
          <SearchIcon style={{ fontSize: '1.5rem' }} />
        </motion.button>
      </Tooltip>

      {/* Search Panel */}
      <AnimatePresence>
        {isSearchOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -20, scale: 0.95 }}
            transition={{ 
              type: 'spring', 
              damping: 25, 
              stiffness: 300,
              mass: 0.5
            }}
            style={{
              position: 'absolute',
              top: '60px',
              right: '0',
              width: 'min(90vw, 420px)',
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              boxShadow: '0 15px 30px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              padding: '0',
              overflow: 'hidden',
              border: '1px solid rgba(0, 0, 0, 0.05)',
            }}
          >
            {/* Search Header */}
            <div style={{
              padding: '20px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon style={{ marginRight: '12px', fontSize: '1.4rem' }} />
                <h3 style={{ margin: 0, fontWeight: 500 }}>
                  {language === "English" ? "Quick Menu" : "द्रुत नेव्हिगेशन"}
                </h3>
              </div>
              <motion.button
                onClick={toggleSearch}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'white',
                  padding: '6px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                whileTap={{ scale: 0.9 }}
              >
                <CloseIcon style={{ fontSize: '1.2rem' }} />
              </motion.button>
            </div>

            {/* Search Input */}
            <div style={{ padding: '20px', paddingBottom: '15px' }}>
              <motion.div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  border: isFocused ? '2px solid #667eea' : '2px solid #e0e0e0',
                  transition: 'all 0.3s ease',
                }}
                whileHover={{ borderColor: '#b3b3b3' }}
              >
                <input
                  type="text"
                  placeholder={language === "English" ? "Type to search..." : "शोधण्यासाठी टाइप करा..."}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  style={{
                    flex: 1,
                    padding: '14px 20px',
                    border: 'none',
                    outline: 'none',
                    fontSize: '16px',
                    backgroundColor: 'transparent',
                  }}
                  autoFocus
                />
                {searchQuery && (
                  <motion.button
                    onClick={() => setSearchQuery("")}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '0 15px',
                      color: '#666',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <CloseIcon style={{ fontSize: '1.1rem' }} />
                  </motion.button>
                )}
              </motion.div>
            </div>

            {/* Search Results */}
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: 'auto' }}
              exit={{ height: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                overflow: 'hidden',
                borderTop: '1px solid #f0f0f0',
              }}
            >
              <div
                style={{
                  maxHeight: '60vh',
                  overflowY: 'auto',
                  padding: '0 20px 20px',
                }}
              >
                {searchQuery ? (
                  filteredItems.length > 0 ? (
                    filteredItems.map((item, index) => (
                      <motion.div 
                        key={index} 
                        style={{ marginBottom: '15px' }}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.05 }}
                      >
                        {item.path && item.path !== null && (
                          <Link
                            to={item.path}
                            style={{
                              display: 'block',
                              padding: '12px 18px',
                              color: '#5a67d8',
                              fontWeight: '600',
                              textDecoration: 'none',
                              borderRadius: '8px',
                              fontSize: '15px',
                              backgroundColor: 'rgba(90, 103, 216, 0.08)',
                              transition: 'all 0.2s ease',
                              borderLeft: '4px solid #5a67d8',
                            }}
                            onClick={handleItemClick}
                          >
                            {item.label}
                          </Link>
                        )}
                        {!item.path && item.label !== getLabel("Refer & Earn", "Refer & Earn") && (
                          <div
                            style={{
                              padding: '12px 18px',
                              color: '#5a67d8',
                              fontWeight: '600',
                              fontSize: '15px',
                              backgroundColor: 'rgba(90, 103, 216, 0.08)',
                              borderRadius: '8px',
                              borderLeft: '4px solid #5a67d8',
                            }}
                          >
                            {item.label}
                          </div>
                        )}
                        {item.children?.length > 0 && (
                          <div style={{ marginLeft: '10px', marginTop: '10px' }}>
                            {item.children.map((child, childIndex) => (
                              child.access && child.path && (
                                <motion.div
                                  key={childIndex}
                                  initial={{ opacity: 0, y: 5 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  transition={{ delay: (index + childIndex) * 0.03 }}
                                >
                                  <Link
                                    to={child.path}
                                    style={{
                                      display: 'block',
                                      padding: '10px 18px',
                                      color: '#4a5568',
                                      textDecoration: 'none',
                                      borderRadius: '6px',
                                      fontSize: '14px',
                                      marginBottom: '8px',
                                      backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                      transition: 'all 0.2s ease',
                                      borderLeft: '3px solid #a0aec0',
                                    }}
                                    onClick={handleItemClick}
                                  >
                                    {child.label}
                                  </Link>
                                </motion.div>
                              )
                            ))}
                          </div>
                        )}
                      </motion.div>
                    ))
                  ) : (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.2 }}
                      style={{
                        padding: '30px 20px',
                        color: '#718096',
                        textAlign: 'center',
                        fontSize: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <SearchIcon style={{ fontSize: '2.5rem', color: '#cbd5e0', marginBottom: '15px' }} />
                      <div style={{ fontWeight: 500, marginBottom: '5px' }}>
                        {language === "English" ? "No results found" : "परिणाम सापडले नाही"}
                      </div>
                      <div style={{ color: '#a0aec0', fontSize: '14px' }}>
                        {language === "English" 
                          ? "Try different keywords" 
                          : "वेगळी कीवर्ड्स वापरून पहा"}
                      </div>
                    </motion.div>
                  )
                ) : (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    style={{
                      padding: '30px 20px',
                      color: '#718096',
                      textAlign: 'center',
                      fontSize: '15px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <SearchIcon style={{ 
                      fontSize: '2.5rem', 
                      color: '#cbd5e0', 
                      marginBottom: '15px',
                      opacity: 0.7
                    }} />
                    <div style={{ fontWeight: 500, marginBottom: '5px' }}>
                      {language === "English" 
                        ? "Search for Menu items" 
                        : "नेव्हिगेशन आयटम शोधा"}
                    </div>
                    <div style={{ color: '#a0aec0', fontSize: '14px' }}>
                      {language === "English" 
                        ? "Type to see suggestions" 
                        : "सूचना पाहण्यासाठी टाइप करा"}
                    </div>
                  </motion.div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NavigationSearchBar;

